<template>
  <div id="admin">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "admin",
};
</script>

<style scoped lang="scss">
header,
table,
#admin {
  min-width: 1440px;
}
</style>
